<h3 class="mb-0">{{"reports-manager.title" | translate}}</h3>
<h5>{{measurement.name}}</h5>
<p class="mb-4">{{"reports-manager.subtitle" | translate}}</p>

<p-divider></p-divider>

<div class="flex justify-content-center">
  <!-- <div class="col-md-6 col-sm-12 p-0"> -->
    @if (rbac.canReadProject()) {
      <button pButton color="primary"
        [disabled]="generatingReport"
        class="w-full md:w-60"
        (click)="generateReport()">
        {{ 'measurement.regenerate-report' | translate}}
      </button>
    }
  <!-- </div> -->
</div>

@if (reportsList) {
  <cosmos-data-table
    [tableData]="reportsList"
    [tableColumns]="columns"
    [rowActions]="actions"
    (rowAction)="rowAction($event)">
  </cosmos-data-table>
}
<p-divider></p-divider>

<p class="mt-4 small">{{"reports-manager.email-info" | translate}}</p>
